const isTrue = (value?: string) => `${value}`.trim().toLowerCase() === 'true';

// Flags de build. CRA sólo expone al bundle las variables con prefijo REACT_APP_,
// el Dockerfile mapea WITH_STATIC_HOME y STATIC_EVENT_LINK a estas.
export const withStaticHome = isTrue(process.env.REACT_APP_WITH_STATIC_HOME);

// Link del evento de la columna derecha de la pre-home (STATIC_EVENT_LINK).
// Acepta una url absoluta o una ruta interna (ej: /evento/38b938a8/step/1).
export const staticEventLink = process.env.REACT_APP_STATIC_EVENT_LINK || '/evento/c0ed1c79/step/1';

// Imagenes de la pre-home (STATIC_HOME_IMAGE / STATIC_EVENT_IMAGE).
// Son urls completas del bucket de imagenes.
export const staticHomeImage = process.env.REACT_APP_STATIC_HOME_IMAGE
  || 'https://imgs.entradaweb.com.ar/folck/home_ew-1.jpg';
export const staticEventImage = process.env.REACT_APP_STATIC_EVENT_IMAGE
  || 'https://imgs.entradaweb.com.ar/folck/SST_MDZ_FilaVirtual_PreVenta-fla-general-2.jpg';

// Ruta de la home original: la raiz, salvo que la pre-home la ocupe.
export const homePath = withStaticHome ? '/home' : '/';

// True cuando estamos parados en la home original (sea '/' o '/home').
export const isHomePath = (pathname: string) => pathname === homePath;

// True sólo cuando la pre-home estática está activa y es la pagina actual.
export const isStaticHomePath = (pathname: string) => withStaticHome && pathname === '/';

// True cuando estamos en la pagina de comunidades (ahi no se muestra el acceso a comunidades).
export const isComunidadesPath = (pathname: string) => pathname === '/comunidades';

export const isExternalLink = (link: string) => /^https?:\/\//i.test(link);
